import { Dispatch, SetStateAction } from 'react';
import { MdOutlineModeEdit } from 'react-icons/md';
import { DiscountsForm, Seasons } from 'types';
import { Accordion, Button } from 'components';
import { DiscountInput } from '../discount-input';

interface Props {
  title?: string;
  seasonName: Seasons;
  values: DiscountsForm;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setSelectedSeason: Dispatch<SetStateAction<Seasons | null>>;
  defaultOpen?: boolean;
}

export function SeasonDiscountTable({
  title = '',
  values,
  seasonName,
  handleChange,
  setSelectedSeason,
  defaultOpen = false,
}: Props) {
  if (values[seasonName].collections.length <= 0) return null;

  return (
    <Accordion
      title={title ? `Descontos da ${title}` : ''}
      alignStart
      defaultOpen={defaultOpen}
    >
      <div className="flex flex-col gap-2">
        <table className="border-spacing-0">
          <thead>
            <tr>
              <th className="h-12 rounded-l-lg bg-neutral-200 px-4 text-sm font-normal">
                Desconto
              </th>
              <th className="h-12 w-full rounded-r-lg bg-neutral-200 px-4 text-start text-sm font-normal">
                Coleção
              </th>
            </tr>
          </thead>

          <div className="h-2" />

          <tbody>
            {values[seasonName].collections.map(({ discount, name }, index) => {
              return (
                <tr>
                  <td className="flex items-center justify-center p-2">
                    <DiscountInput
                      name={`${seasonName}.collections[${index}].discount`}
                      value={discount}
                      onChange={handleChange}
                    />
                  </td>

                  <td className="px-4 text-xs font-bold">{name}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <Button onClick={() => setSelectedSeason(seasonName)} variant="link">
          <MdOutlineModeEdit size={20} />
          Alterar todas as coleções
        </Button>
      </div>
    </Accordion>
  );
}
